import { FormEvent, FunctionComponent, useCallback, useMemo, useState } from 'react';
import { StepContainer } from '../../../../StepContainer';
import { useRequestCheckoutContext } from '../../../../CheckoutContext/RequestContext';
import { RequestCheckoutState } from '@shared/types';
import { DateInputs } from '../DateInputs';
import styles from './styles.module.scss';

export type PreferredDatesStepProps = {};

export const PreferredDatesStep: FunctionComponent<PreferredDatesStepProps> = () => {
    const { course, checkoutState, submitResponse } = useRequestCheckoutContext();

    const initialDates = useMemo((): Array<string> => {
        if (checkoutState.stepState.dates.status !== 'complete') {
            return [''];
        }
        if (checkoutState.stepState.dates.state.type !== 'preferred dates') {
            return [checkoutState.stepState.dates.state.availableDate];
        }
        return checkoutState.stepState.dates.state.preferredDates;
    }, [checkoutState]);

    const [dates, setDates] = useState<Array<string>>(initialDates);

    const onContinue = useCallback(() => {
        submitResponse({
            actionType: 'request preferred dates selected',
            payload: {
                preferredDates: dates,
            },
        });
    }, [dates, submitResponse]);

    const onBackClick = useCallback(() => {
        return submitResponse({ actionType: 'go back', payload: {} });
    }, [submitResponse]);

    const optimisticCheckoutState = useMemo((): RequestCheckoutState => {
        return {
            ...checkoutState,
            stepState: {
                ...checkoutState.stepState,
                dates: {
                    status: 'complete',
                    state: {
                        type: 'preferred dates',
                        preferredDates: dates,
                    },
                },
            },
        };
    }, [checkoutState, dates]);

    const onFormSubmit = useCallback((event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    }, []);

    return (
        <form onSubmit={onFormSubmit}>
            <StepContainer
                course={course}
                optimisticCheckoutState={optimisticCheckoutState}
                onContinueClick={onContinue}
                onBackClick={onBackClick}
            >
                <div className={styles.container}>
                    <DateInputs dates={dates} setDates={setDates} />
                </div>
            </StepContainer>
        </form>
    );
};
